<template>
  <tree-select
    ref="treeSelect"
    :props="props"
    :options="data"
    :value="value1"
    parent-select
    :clearable="false"
    placeholder="请选择"
    @node-select="select($event)"
  />
</template>
<script>
import treeSelect from "@/components/common/treeSelect";
export default {
  components: { treeSelect },
  props: {
    value: {},
  },
  data() {
    return {
      api: require("@/api/ba/class").default,
      value1: this.value,
      data: [],
      props: {
        // 配置项（必选）
        value: "ClassId",
        label: "ClassName",
        children: "children",
      },
    };
  },
  methods: {
    init(params = {}) {
      params = { ...params, ClassType: 4 };
      this.api.list(params).then((res) => {
        this.data = this.$commonJs.toTreeData(res.Data, "ClassId");
        this.setData();
      });
    },
    clear() {
      this.$refs.treeSelect.clearHandle();
    },
    setData() {
      this.$nextTick(() => {
        this.value1 = this.value;
        this.$refs.treeSelect.setData();
      });
    },
    select(e) {
      if (e) this.$emit("input", e.ClassId);
      else this.$emit("input", null);
    },
  },
};
</script>